import config from "../../config/config";

export const hasPermission = (permissionsData, category, requiredLevel = "VIEW_ONLY") => {
  if (!config.enablePermissionCheck) return true;

  if (!permissionsData || !permissionsData.permissions) return false;

  const permission = permissionsData.permissions.find(
    (p) => p.category === category
  );

  if (!permission) return false;

  const level = permission.permissionLevel;

  // Permission hierarchy
  const levels = {
    NO_ACCESS: 0,
    VIEW_ONLY: 1,
    READ_WRITE: 2,
  };

  return levels[level] >= levels[requiredLevel];
};

